import React, { useEffect, useRef, useState } from "react";
import "./App.css";

import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

import CVFile from "./Omar Hamsho Ludwigsburg (1).pdf";

const SECTION_IDS = ["home", "about", "skills", "experience", "education", "projects", "contact"];

function AppShell() {
    const [activeSection, setActiveSection] = useState("home");
    const observerRef = useRef(null);

    useEffect(() => {
        const sections = SECTION_IDS.map((id) => document.getElementById(id)).filter(Boolean);

        observerRef.current = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
        );

        sections.forEach((section) => observerRef.current.observe(section));
        return () => observerRef.current?.disconnect();
    }, []);

    return (
        <div className="app">
            <Navbar activeSection={activeSection} cvHref={CVFile} />
            <main>
                <Hero cvHref={CVFile} />
                <About />
                <Skills />
                <Experience />
                <Education />
                <Projects />
                <Contact cvHref={CVFile} />
            </main>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <ThemeProvider>
            <LanguageProvider>
                <AppShell />
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;
